import { render, staticRenderFns } from "./AthleteComparativeDataPerformance.vue?vue&type=template&id=262fa95a&scoped=true&"
import script from "./AthleteComparativeDataPerformance.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataPerformance.vue?vue&type=style&index=0&id=262fa95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262fa95a",
  null
  
)

export default component.exports